module.exports = __webpack_public_path__ + "img/close.a6fef1e1.png";